import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { GET_CONFIGS } from "./actionTypes"
import { configSuccess, configError } from "./actions"

//Include Both Helper File with needed methods
import {
  getShortcodes,
} from "../../helpers/config_helper"

function* getConfig(data) {
  try {
    const response = yield call(getShortcodes, data)
    yield put(configSuccess(response))
  } catch (error) {
    yield put(configError(error))
  }
}
// export function* watchConfig() {
//   yield takeEvery(GET_CONFIGS, getConfig)
// }

function* ConfigSaga() {
  yield takeEvery(GET_CONFIGS, getConfig)
  // yield all([fork(watchConfig)])
}

export default ConfigSaga
